import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IQuestionnaireBlock } from 'src/actions/questionnaire';
import { EnqueteType } from '../actions/eLearning';
import { IMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import { IQuestionnaireProps } from '../containers/ELearningQuestionnaire';
import QuestionnaireGrid from '../containers/QuestionnaireGrid';
import QuestionnaireNormal from '../containers/QuestionnaireNormal';
import QuestionnaireWizard from '../containers/QuestionnaireWizard';
import { IRootState } from '../reducers';
import { Routes, Screens } from '../utils/Routes';
const styles = (theme: Theme) =>
	createStyles({
		paper: {
			margin: theme.spacing(1),
			padding: theme.spacing(3),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
	});

interface IState {
	errorMessage: IMessage[];
	openErrorDialog: boolean;
}

const questionnaireMap: {
	[T in EnqueteType]: React.ComponentType<IQuestionnaireProps>
} = {
	'1': QuestionnaireNormal,
	'2': QuestionnaireGrid,
	'3': QuestionnaireWizard,
};

/**
 * アンケートフォームコンポーネント
 */
class QuestionnaireForm extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			errorMessage: [],
			openErrorDialog: false,
		};
	}

	public render() {
		if (!(this.props.type in questionnaireMap)) {
			return <div />;
		}

		const Questionnaire = questionnaireMap[this.props.type];

		return (
			<React.Fragment>
				<Questionnaire
					careerID={this.props.careerID}
					classID={this.props.classID}
					outOfPeriodFlg={false}
					preview={false}
					unAnsweredCheck={this.unAnsweredCheck}
					id={this.props.id}
					onReported={this.handleReported}
					flg={this.props.flg}
					onlyQuestionFlg={this.props.onlyQuestionFlg}
					assessmentFlg={this.props.assessmentFlg}
					accessFlg={0}
				/>
				<MessageDialog
					open={this.state.openErrorDialog}
					onClose={this.closeErrorDialog}
					contents={this.state.errorMessage}
					showCancelButton={false}
					onClickOk={this.closeErrorDialog}
				/>
			</React.Fragment>
		);
	}

	/**
	 * 未回答チェック
	 */
	protected unAnsweredCheck = (
		mustAnswerFlg: number,
		updatedBlocks: IQuestionnaireBlock[]
	): boolean => {
		if (mustAnswerFlg === 1) {
			const unanswerd = updatedBlocks.some(block =>
				block.questionnaires.some(enq => {
					switch (enq.questionnaireType) {
						case '3': // 複数選択
							return (
								enq.options &&
								!enq.options.some(opt => opt.selected === true)
							);
						case '4': // 記述
							return (
								enq.options && enq.options[0].replyText === ''
							);
						case '1': // プルダウン
						case '2': // ラジオ
						default:
							return enq.selectedReply === 0;
					}
				})
			);

			if (unanswerd) {
				const message: IMessage = {
					content: 'LMCM_E_00441',
				};
				this.setState({
					errorMessage: [message],
					openErrorDialog: true,
				});
			}

			return unanswerd;
		} else {
			let unanswerdBlockQuestionList: string[] = [];
			updatedBlocks.map(block => {
				const unanswerdQuestion = block.questionnaires.filter(
					questionnaireInfo => {
						return (
							questionnaireInfo.mustFlg === 1 &&
							((questionnaireInfo.questionnaireType === '3' &&
								(questionnaireInfo.options &&
									!questionnaireInfo.options.some(
										opt => opt.selected === true
									))) ||
								(questionnaireInfo.questionnaireType === '4' &&
									(questionnaireInfo.options &&
										questionnaireInfo.options[0]
											.replyText === '')) ||
								(questionnaireInfo.questionnaireType !== '3' &&
									questionnaireInfo.questionnaireType !==
										'4' &&
									questionnaireInfo.selectedReply === 0))
						);
					}
				);

				const unanswerdBlockQuestion: string[] = unanswerdQuestion.map(
					item => {
						return `${
							block.blockName
						}-${item.questionnaireNo.substring(
							0,
							item.questionnaireNo.length - 1
						)}`;
					}
				);
				unanswerdBlockQuestionList = [
					...unanswerdBlockQuestionList,
					...unanswerdBlockQuestion,
				];
			});

			if (unanswerdBlockQuestionList.length === 0) {
				return false;
			} else {
				let content = unanswerdBlockQuestionList.toString();
				content = content.replace(/,/g, '<br/>');
				const message: IMessage = {
					content: 'LMCM_E_15511',
					replacements: [
						'<span style="color:#FF0000;font-weight:bold;">',
						'</span>',
						content,
					],
				};
				this.setState({
					errorMessage: [message],
					openErrorDialog: true,
				});
				return true;
			}
		}
	};

	/**
	 * エラーダイアログオープン
	 */
	protected openErrorDialog = () => {
		this.setState({ openErrorDialog: true });
	};

	/**
	 * エラーダイアログクローズ
	 */
	protected closeErrorDialog = () => {
		this.setState({ openErrorDialog: false });
	};

	/**
	 * アンケート提出ハンドラ
	 */
	protected handleReported = () => {
		this.props.backToList(this.props.careerID, this.props.classID);
	};
}

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	backToList: (careerID: string, classID: string) => {
		let pathname = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
		pathname = pathname.replace(/\/:career_id\//, `/${careerID}/`);
		pathname = pathname.replace(/\/:class_id/, `/${classID}`);
		dispatch(push(pathname));
	},
});

export interface IQuestionnaireFormProps {
	careerID: string;
	classID: string;
	id: string;
	type: string;
	flg: number;
	assessmentFlg: boolean;
	onlyQuestionFlg: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IQuestionnaireFormProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuestionnaireForm);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuestionnaireForm.tsx